import * as React from 'react'
import {
  styleguide,
  Column,
  Divider,
  Text,
  Row,
  Layout,
  DotDivider,
} from 'styleguide'
import * as Illustrations from '../Illustrations'
import Carousel from './Carousel'
const slideStyles = [
  { x: 0, s: 1, o: 1 },
  { x: -40, s: 0.8, o: 0.8 },
  { x: -60, s: 0.6, o: 0.6 },
]
const outSlideStyles = { x: 100, s: 2, o: 0 }
export default function({ className }) {
  return (
    <Layout size="large" align="stretch">
      <Row
        justify="space-between"
        align="stretch"
        css={`
          z-index: 3;
        `}>
        <Row
          align="start"
          css={`
            max-width: 35%;
          `}>
          {/* <Icon
            icon="chart"
            primary
            css={`
              margin-right: 20px;
              margin-top: 3px;
            `}
          /> */}
          <Column>
            <Text title bold serif primary>
              Case Studies
            </Text>
            <DotDivider />
            <Column
              css={`
                margin-bottom: 20px;
              `}>
              <Text bold> Why are our users emptying their cart? </Text>
              <Text small subtext pt>
                Lululemon
              </Text>
            </Column>
            <Divider inline />
            <Column
              css={`
                margin-top: 20px;
              `}>
              <Text bold>What makes our users choose an article?</Text>
              <Text small subtext pt>
                Medium
              </Text>
            </Column>
          </Column>
        </Row>
        <Column grow>
          <Column
            css={`
              height: 400px;
              left: 0;
              opacity: 0;
            `}
          />
          <Carousel numSlides={2}>
            {({ activeSlideIndex, onGoToSlide }) => (
              <div
                css={`
                  position: absolute;
                  top: 0;
                  bottom: 0;
                  right: 0;
                  left: 120px;
                `}>
                {[0, 1, 2].map(index => {
                  const style = slideStyles[activeSlideIndex - index]
                  const activeStyle = style ? style : outSlideStyles
                  return (
                    <Column
                      key={index}
                      css={`
                      height: 400px;
                      position: absolute !important;
                      left: 0;
                      opacity: ${index > activeSlideIndex ? 0 : activeStyle.o};
                      transform: translate3d(
                        ${activeStyle.x}px,
                        0,
                        0
                      ) scale3d(${activeStyle.s}, ${activeStyle.s}, 1);
                      z-index: ${index}
                      margin-left: 40px;
                      transform-origin: left;
                      transition: all 500ms ease;
                      background-color: ${styleguide.colors.background};
                      border-radius: ${styleguide.radii.outer};
                      overflow: hidden;
                      position: relative;
                      z-index: 4;
                      padding: 80px;
                      ${styleguide.shadows.button};
                    `}>
                      <Text
                        subtitle
                        subtext
                        bold
                        serif
                        css={`
                          line-height: 150%;
                        `}>
                        “ I need to redesign the article card, but I don’t know
                        what parts of the card UI catch a users eye…
                      </Text>
                      <Text
                        secondary
                        small
                        css={`
                          margin-top: 40px;
                        `}>
                        - Product Manager Joe
                      </Text>
                    </Column>
                  )
                })}
              </div>
            )}
          </Carousel>
        </Column>
      </Row>
      <div
        css={`
          position: absolute;
          width: 100%;
          height: 100%;
          opacity: 0.6;
        `}>
        <Illustrations.Stripes
          color="primary"
          css={`
            position: absolute;
            right: -60px;
            top: 100px;
            width: 700px;
            height: 700px;
            z-index: 0;
          `}
        />
      </div>
    </Layout>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sections/CaseStudies.jsx